export const tiptapEditorActions = {
    // Main editor content
    UPDATE_CURRENT_EDITOR_CONTENT: 'TIPTAP_EDITOR/UPDATE_CURRENT_EDITOR_CONTENT',
    ADDITIONAL_CONTENT_TO_EDITOR: 'TIPTAP_EDITOR/ADDITIONAL_CONTENT_TO_EDITOR',
    UPDATE_CURRENT_EDITOR_TEXT: 'TIPTAP_EDITOR/UPDATE_CURRENT_EDITOR_TEXT',
    NEW_TITLE_CONTENT_TO_OUTLINE_EDITOR: 'TIPTAP_EDITOR/NEW_TITLE_CONTENT_TO_OUTLINE_EDITOR',

    // Loadings
    UPDATE_CURRENT_EDITOR_LOADING: 'TIPTAP_EDITOR_LOADING/UPDATE_CURRENT_EDITOR_LOADING',
    UPDATE_SAVE_EDITOR_LOADING: 'TIPTAP_EDITOR_LOADING/UPDATE_SAVE_EDITOR_LOADING',
    UPDATE_PREVIEW_VERSION_CONTENT_LOADING:
        'TIPTAP_EDITOR_LOADING/UPDATE_PREVIEW_VERSION_CONTENT_LOADING',

    // Versions
    UPDATE_EDITOR_VERSIONS: 'TIPTAP_EDITOR_VERSIONS/UPDATE_EDITOR_VERSIONS',
    UPDATE_EDITOR_VERSIONS_SCORES: 'TIPTAP_EDITOR_VERSIONS/UPDATE_EDITOR_VERSIONS_SCORES',
    ADD_EDITOR_VERSION: 'TIPTAP_EDITOR_VERSIONS/ADD_EDITOR_VERSION',
    UPDATE_EDITOR_DATA_AFTER_SAVE: 'TIPTAP_EDITOR_VERSIONS/UPDATE_EDITOR_DATA_AFTER_SAVE',
    UPDATE_EDITOR_BASIC_DATA: 'TIPTAP_EDITOR_VERSIONS/UPDATE_EDITOR_BASIC_DATA',
    UPDATE_CURRENT_EDITOR_VERSION: 'TIPTAP_EDITOR_VERSIONS/UPDATE_CURRENT_EDITOR_VERSION',
    UPDATE_EDITOR_CURRENT_VERSION_SCORE:
        'TIPTAP_EDITOR_VERSIONS/UPDATE_EDITOR_CURRENT_VERSION_SCORE',
    UPDATE_EDITOR_CURRENT_VERSION_WORD_COUNT:
        'TIPTAP_EDITOR_VERSIONS/UPDATE_EDITOR_CURRENT_VERSION_WORD_COUNT',
    UPDATE_EDITOR_CURRENT_VERSION_HEADING_COUNT:
        'TIPTAP_EDITOR_VERSIONS/UPDATE_EDITOR_CURRENT_VERSION_HEADING_COUNT',
    UPDATE_OPTIMIZER_EDITOR_VERSION_IMPORTED_URL:
        'TIPTAP_EDITOR_VERSIONS/UPDATE_OPTIMIZER_EDITOR_VERSION_IMPORTED_URL',
    SET_EDITOR_PREVIEW_VERSION: 'TIPTAP_EDITOR_VERSIONS/SET_EDITOR_PREVIEW_VERSION',
    UPDATE_EDITOR_VERSION_NAME: 'TIPTAP_EDITOR_VERSIONS/UPDATE_EDITOR_VERSION_NAME',
    DELETE_EDITOR_VERSION: 'TIPTAP_EDITOR_VERSIONS/DELETE_EDITOR_VERSION',

    // Settings
    UPDATE_HTML_TAGS: 'TIPTAP_EDITOR_SETTINGS/UPDATE_HTML_TAGS',
    UPDATE_HIGHLIGHT_KEYWORDS: 'TIPTAP_EDITOR_SETTINGS/UPDATE_HIGHLIGHT_KEYWORDS',
    UPDATE_EDITOR_FULL_WIDTH: 'TIPTAP_EDITOR_SETTINGS/UPDATE_EDITOR_FULL_WIDTH',
    UPDATE_TABLE_OF_CONTENTS: 'TIPTAP_EDITOR_SETTINGS/UPDATE_TABLE_OF_CONTENTS',
    SET_TABLE_OF_CONTENT_ITEMS: 'TIPTAP_EDITOR_SETTINGS/SET_TABLE_OF_CONTENT_ITEMS',

    // AI Token generation
    SET_GENERATED_AI_TOKEN: 'TIPTAP_AI/SET_GENERATED_AI_TOKEN',
    SET_AI_SPELL_CHECKER_VISIBLE: 'TIPTAP_AI/SET_AI_SPELL_CHECKER_VISIBLE',
    SET_AI_STATE: 'TIPTAP_AI/SET_AI_STATE',
    RESET_AI_STATE: 'TIPTAP_AI/RESET_AI_STATE',
    SET_AI_OPTIMIZED_ID: 'TIPTAP_AI/SET_AI_OPTIMIZED_ID',

    // Clear editor data
    CLEAR_TIPTAP_EDITOR: 'TIPTAP_EDITOR/CLEAR_TIPTAP_EDITOR',
    CLEAR_EDITOR_BY_TYPE: 'TIPTAP_EDITOR/CLEAR_EDITOR_BY_TYPE',
};

// Settings
export const updateEditorHtmlTags = (payload) => ({
    type: tiptapEditorActions.UPDATE_HTML_TAGS,
    payload,
});
export const updateEditorHighlightKeywords = (payload) => ({
    type: tiptapEditorActions.UPDATE_HIGHLIGHT_KEYWORDS,
    payload,
});
export const updateEditorFullWidth = (payload) => ({
    type: tiptapEditorActions.UPDATE_EDITOR_FULL_WIDTH,
    payload,
});
export const updateEditorTableOfContents = (payload) => ({
    type: tiptapEditorActions.UPDATE_TABLE_OF_CONTENTS,
    payload,
});
export const setTableOfContentItems = (payload) => ({
    type: tiptapEditorActions.SET_TABLE_OF_CONTENT_ITEMS,
    payload,
});

// Versions
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.versions - versions data to update in store
 */
export const updateEditorVersions = (payload) => ({
    type: tiptapEditorActions.UPDATE_EDITOR_VERSIONS,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.scores - versions scores data to update in store
 */
export const updateEditorVersionsScores = (payload) => ({
    type: tiptapEditorActions.UPDATE_EDITOR_VERSIONS_SCORES,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.version - current version data to update in store
 */
export const updateCurrentEditorVersion = (payload) => ({
    type: tiptapEditorActions.UPDATE_CURRENT_EDITOR_VERSION,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.version - version data to add in store
 */
export const addEditorVersion = (payload) => ({
    type: tiptapEditorActions.ADD_EDITOR_VERSION,
    payload,
});

export const updateEditorBasicData = (payload) => {
    const {
        readability,
        rankability_score,
        word_count,
        optimal_readability,
        optimal_rankability_score,
        optimal_word_count,
    } = payload;

    return {
        type: tiptapEditorActions.UPDATE_EDITOR_BASIC_DATA,
        payload: {
            readability,
            rankability_score,
            word_count,
            optimal_readability,
            optimal_rankability_score,
            optimal_word_count,
        },
    };
};
export const updateEditorOptimalsBasicData = (payload) => {
    const { optimal_readability, optimal_rankability_score, optimal_word_count } = payload;

    return {
        type: tiptapEditorActions.UPDATE_EDITOR_BASIC_DATA,
        payload: {
            optimal_readability,
            optimal_rankability_score,
            optimal_word_count,
        },
    };
};
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.score - version score to update in store
 */
export const updateEditorCurrentVersionScore = (payload) => ({
    type: tiptapEditorActions.UPDATE_EDITOR_CURRENT_VERSION_SCORE,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.wordCount - version word count to update in store
 */
export const updateEditorCurrentVersionWordCount = (payload) => ({
    type: tiptapEditorActions.UPDATE_EDITOR_CURRENT_VERSION_WORD_COUNT,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.headingCount - version heading count to update in store
 */
export const updateEditorCurrentVersionHeadingCount = (payload) => ({
    type: tiptapEditorActions.UPDATE_EDITOR_CURRENT_VERSION_HEADING_COUNT,
    payload,
});
export const updateOptimizerEditorVersionImportedUrl = (payload) => ({
    type: tiptapEditorActions.UPDATE_OPTIMIZER_EDITOR_VERSION_IMPORTED_URL,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.versionId - version id to set as preview
 * @param {Object} payload.updateBasicData - update basic data in store
 */
export const setEditorPreviewVersion = (payload) => {
    const { editorType, versionId, updateBasicData, versionContent } = payload;

    return {
        type: tiptapEditorActions.SET_EDITOR_PREVIEW_VERSION,
        payload: {
            editorType,
            versionId,
            updateBasicData,
            versionContent,
        },
    };
};
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.id - version id to update
 * @param {Object} payload.name - version name to update
 */
export const updateEditorVersionName = (payload) => ({
    type: tiptapEditorActions.UPDATE_EDITOR_VERSION_NAME,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {Object} payload.id - version id to delete
 */
export const deleteEditorVersion = (payload) => ({
    type: tiptapEditorActions.DELETE_EDITOR_VERSION,
    payload,
});

// Loadings
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {boolean} payload.loading - loading state to update
 */
export const updateSaveEditorLoading = (payload) => ({
    type: tiptapEditorActions.UPDATE_SAVE_EDITOR_LOADING,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {boolean} payload.loading - loading state to update
 */
export const updateCurrentEditorLoading = (payload) => ({
    type: tiptapEditorActions.UPDATE_CURRENT_EDITOR_LOADING,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {boolean} payload.loading - loading state to update
 */
export const updatePreviewVersionContentLoading = (payload) => ({
    type: tiptapEditorActions.UPDATE_PREVIEW_VERSION_CONTENT_LOADING,
    payload,
});

// Main editor content
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {string} payload.content - content to update
 */
export const updateCurrentEditorContent = (payload) => ({
    type: tiptapEditorActions.UPDATE_CURRENT_EDITOR_CONTENT,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {string | null} payload.content - content to add
 */
export const additionalContentToEditor = (payload) => ({
    type: tiptapEditorActions.ADDITIONAL_CONTENT_TO_EDITOR,
    payload,
});
/**
 * @param {Object} payload - common payload
 * @param {string} payload.editorType - type of editor (optimizer, outline)
 * @param {string} payload.text - text to update
 */
export const updateCurrentEditorText = (payload) => ({
    type: tiptapEditorActions.UPDATE_CURRENT_EDITOR_TEXT,
    payload,
});
export const updateOutlineEditorNewTitleContent = (payload) => ({
    type: tiptapEditorActions.NEW_TITLE_CONTENT_TO_OUTLINE_EDITOR,
    payload,
});

// AI Token Generation
export const setGeneratedAIToken = (payload) => ({
    type: tiptapEditorActions.SET_GENERATED_AI_TOKEN,
    payload,
});
export const setAIState = (payload) => ({
    type: tiptapEditorActions.SET_AI_STATE,
    payload,
});
export const setAISpellCheckerVisible = (payload) => ({
    type: tiptapEditorActions.SET_AI_SPELL_CHECKER_VISIBLE,
    payload,
});
export const resetAIState = () => ({
    type: tiptapEditorActions.RESET_AI_STATE,
});
export const setAIOptimizerId = (payload) => ({
    type: tiptapEditorActions.SET_AI_OPTIMIZED_ID,
    payload,
});

// Clear editor data
export const clearContentOptimizerEditor = () => ({
    type: tiptapEditorActions.CLEAR_TIPTAP_EDITOR,
});

export const clearEditorByType = (payload) => ({
    type: tiptapEditorActions.CLEAR_EDITOR_BY_TYPE,
    payload,
});
